'use strict';
const angular = require('angular');

export class iFrameWidgetComponent {

  constructor($sce) {
    'ngInject';

    this.$sce = $sce;
  }

  $onInit() {
    this.trustedUrl = this.$sce.trustAsResourceUrl(this.url);
    this.width = this.width || '100%';
    this.height = this.height || '300px';
  }
}

export default angular.module('conduuApp.iFrameWidget', [])
  .component('iframeWidget', {
    template: `<iframe frameborder='0' height="{{$ctrl.height}}" width="{{$ctrl.width}}" ng-src='{{$ctrl.trustedUrl}}'></iframe>`,
    bindings: {
      url: '@',
      width: '@',
      height: '@'
    },
    controller: iFrameWidgetComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/sidebar/iframe-widget/iframe-widget.component.js